export const settings = {
	data: listingAppData,
	perPage: 16,
	filters: [
		{
            name: 'Neigborhoods',
            field: 'city_neighborhood',
            type: 'multiselect',
            options: [
                // {
                //     "name": "Andover",
                //     "value": "Andover",
                //     options: [
                //         {
                //             "name": "Ballardvale",
                //             "value": "Andover:Ballardvale"
                //         },
                //         {
                //             "name": "Haggatts Station",
                //             "value": "Andover:Haggatts Station"
                //         },
                //         {
                //             "name": "In Town",
                //             "value": "Andover:In Town"
                //         },
                //         {
                //             "name": "Shawsheen",
                //             "value": "Andover:Shawsheen"
                //         },
                //         {
                //             "name": "Shawsheen Heights",
                //             "value": "Andover:Shawsheen Heights"
                //         },
                //         {
                //             "name": "Shawsheen Village",
                //             "value": "Andover:Shawsheen Village"
                //         },
                //         {
                //             "name": "South Andover",
                //             "value": "Andover:South Andover"
                //         },
                //         {
                //             "name": "West Andover",
                //             "value": "Andover:West Andover"
                //         },
                //     ]
                // },
                // {
                //     "name": "Arlington",
                //     "value": "Arlington",
                //     options: [
                //         {
                //             "name": "Arlington Center",
                //             "value": "Arlington:Arlington Center"
                //         },
                //         {
                //             "name": "Arlington Heights",
                //             "value": "Arlington:Arlington Heights"
                //         },
                //         {
                //             "name": "Brattle Station",
                //             "value": "Arlington:Brattle Station"
                //         },
                //         {
                //             "name": "East Arlington",
                //             "value": "Arlington:East Arlington"
                //         },
                //         {
                //             "name": "Morningside",
                //             "value": "Arlington:Morningside"
                //         },
                //     ]
                // },
                // {
                //     "name": "Avon",
                //     "value": "Avon"
                // },
                {
                    "name": "Belmont",
                    "value": "Belmont",
                    options: [
                        {
                            "name": "Payson Park",
                            "value": "Belmont:Payson Park"
                        },
                        {
                            "name": "Waverley",
                            "value": "Belmont:Waverley"
                        },
                    ]
                },
                {
                    "name": "Boston",
                    "value": "Boston",
                    options: [
                        {
                            "name": "Allston",
                            "value": "Boston:Allston"
                        },
                        {
                            "name": "Back Bay",
                            "value": "Boston:Back Bay"
                        },
                        {
                            "name": "Bay Village",
                            "value": "Boston:Bay Village"
                        },
                        {
                            "name": "Beacon Hill",
                            "value": "Boston:Beacon Hill"
                        },
                        {
                            "name": "Brighton",
                            "value": "Boston:Brighton"
                        },
                        {
                            "name": "Charlestown",
                            "value": "Boston:Charlestown"
                        },
                        {
                            "name": "Chinatown",
                            "value": "Boston:Chinatown"
                        },
                        {
                            "name": "Dorchester",
                            "value": "Boston:Dorchester"
                        },
                        {
                            "name": "East Boston",
                            "value": "Boston:East Boston"
                        },
                        {
                            "name": "Fenway",
                            "value": "Boston:Fenway"
                        },
                        {
                            "name": "Financial District",
                            "value": "Boston:Financial District"
                        },
                        {
                            "name": "Fort Hill",
                            "value": "Boston:Fort Hill"
                        },
                        {
                            "name": "Hyde Park",
                            "value": "Boston:Hyde Park"
                        },
                        {
                            "name": "Jamaica Plain",
                            "value": "Boston:Jamaica Plain"
                        },
                        {
                            "name": "Kenmore",
                            "value": "Boston:Kenmore"
                        },
                        {
                            "name": "Leather District",
                            "value": "Boston:Leather District"
                        },
                        {
                            "name": "Mattapan",
                            "value": "Boston:Mattapan"
                        },
                        {
                            "name": "Midtown",
                            "value": "Boston:Midtown"
                        },
                        {
                            "name": "Mission Hill",
                            "value": "Boston:Mission Hill"
                        },
                        {
                            "name": "North End",
                            "value": "Boston:North End"
                        },
                        {
                            "name": "Roslindale",
                            "value": "Boston:Roslindale"
                        },
                        {
                            "name": "Roxbury",
                            "value": "Boston:Roxbury"
                        },
                        {
                            "name": "Seaport District",
                            "value": "Boston:Seaport District"
                        },
                        {
                            "name": "South Boston",
                            "value": "Boston:South Boston"
                        },
                        {
                            "name": "South End",
                            "value": "Boston:South End"
                        },
                        {
                            "name": "Theatre District",
                            "value": "Boston:Theatre District"
                        },
                        {
                            "name": "Waterfront",
                            "value": "Boston:Waterfront"
                        },
                        {
                            "name": "West End",
                            "value": "Boston:West End"
                        },
                        {
                            "name": "West Roxbury",
                            "value": "Boston:West Roxbury"
                        },
                    ]
                },
                // {
                //     "name": "Braintree",
                //     "value": "Braintree",
                //     options: [
                //         {
                //             "name": "Braintree Highlands",
                //             "value": "Braintree:Braintree Highlands"
                //         },
                //         {
                //             "name": "East Braintree",
                //             "value": "Braintree:East Braintree"
                //         },
                //         {
                //             "name": "Five Corners",
                //             "value": "Braintree:Five Corners"
                //         },
                //         {
                //             "name": "South Braintree",
                //             "value": "Braintree:South Braintree"
                //         },
                //     ]
                // },
                {
                    "name": "Brookline",
                    "value": "Brookline",
                    options: [
                        {
                            "name": "Beaconsfield",
                            "value": "Brookline:Beaconsfield"
                        },
                        {
                            "name": "Brookline Hills",
                            "value": "Brookline:Brookline Hills"
                        },
                        {
                            "name": "Brookline Village",
                            "value": "Brookline:Brookline Village"
                        },
                        {
                            "name": "Chestnut Hill",
                            "value": "Brookline:Chestnut Hill"
                        },
                        {
                            "name": "Coolidge Corner",
                            "value": "Brookline:Coolidge Corner"
                        },
                        {
                            "name": "Longwood",
                            "value": "Brookline:Longwood"
                        },
                        {
                            "name": "Reservoir",
                            "value": "Brookline:Reservoir"
                        },
                        {
                            "name": "Washington Square",
                            "value": "Brookline:Washington Square"
                        },
                    ]
                },
                {
                    "name": "Cambridge",
                    "value": "Cambridge",
                    options: [
                        {
                            "name": "Agassiz",
                            "value": "Cambridge:Agassiz"
                        },
                        {
                            "name": "Cambridge Highlands",
                            "value": "Cambridge:Cambridge Highlands"
                        },
                        {
                            "name": "Cambridgeport",
                            "value": "Cambridge:Cambridgeport"
                        },
                        {
                            "name": "Central Square",
                            "value": "Cambridge:Central Square"
                        },
                        {
                            "name": "East Cambridge",
                            "value": "Cambridge:East Cambridge"
                        },
                        {
                            "name": "Harvard Square",
                            "value": "Cambridge:Harvard Square"
                        },
                        {
                            "name": "Huron Village",
                            "value": "Cambridge:Huron Village"
                        },
                        {
                            "name": "Inman Square",
                            "value": "Cambridge:Inman Square"
                        },
                        {
                            "name": "Kendall Square",
                            "value": "Cambridge:Kendall Square"
                        },
                        {
                            "name": "Mid Cambridge",
                            "value": "Cambridge:Mid Cambridge"
                        },
                        {
                            "name": "Neighborhood Nine",
                            "value": "Cambridge:Neighborhood Nine"
                        },
                        {
                            "name": "North Cambridge",
                            "value": "Cambridge:North Cambridge"
                        },
                        {
                            "name": "Porter Square",
                            "value": "Cambridge:Porter Square"
                        },
                        {
                            "name": "Riverside",
                            "value": "Cambridge:Riverside"
                        },
                        {
                            "name": "Wellington-Harrington",
                            "value": "Cambridge:Wellington-Harrington"
                        },
                        {
                            "name": "West Cambridge",
                            "value": "Cambridge:West Cambridge"
                        },
                    ]
                },
                // {
                //     "name": "Canton",
                //     "value": "Canton",
                //     options: [
                //         {
                //             "name": "Canton Junction",
                //             "value": "Canton:Canton Junction"
                //         },
                //         {
                //             "name": "Ponkapoag",
                //             "value": "Canton:Ponkapoag"
                //         },
                //         {
                //             "name": "Springdale",
                //             "value": "Canton:Springdale"
                //         },
                //     ]
                // },
                // {
                //     "name": "Danvers",
                //     "value": "Danvers",
                //     options: [
                //         {
                //             "name": "Burleys Corner",
                //             "value": "Danvers:Burleys Corner"
                //         },
                //         {
                //             "name": "Danvers Center",
                //             "value": "Danvers:Danvers Center"
                //         },
                //         {
                //             "name": "Danversport",
                //             "value": "Danvers:Danversport"
                //         },
                //         {
                //             "name": "East Danvers",
                //             "value": "Danvers:East Danvers"
                //         },
                //         {
                //             "name": "Ferncroft",
                //             "value": "Danvers:Ferncroft"
                //         },
                //         {
                //             "name": "Hathorne",
                //             "value": "Danvers:Hathorne"
                //         },
                //         {
                //             "name": "Putnamville",
                //             "value": "Danvers:Putnamville"
                //         },
                //         {
                //             "name": "Tapleyville",
                //             "value": "Danvers:Tapleyville"
                //         },
                //     ]
                // },
                // {
                //     "name": "Dedham",
                //     "value": "Dedham",
                //     options: [
                //         {
                //             "name": "Ashcroft",
                //             "value": "Dedham:Ashcroft"
                //         },
                //         {
                //             "name": "East Dedham",
                //             "value": "Dedham:East Dedham"
                //         },
                //         {
                //             "name": "Endicott",
                //             "value": "Dedham:Endicott"
                //         },
                //         {
                //             "name": "Fairbanks Park",
                //             "value": "Dedham:Fairbanks Park"
                //         },
                //         {
                //             "name": "Greenlodge",
                //             "value": "Dedham:Greenlodge"
                //         },
                //         {
                //             "name": "Oakdale",
                //             "value": "Dedham:Oakdale"
                //         },
                //         {
                //             "name": "Readville Manor",
                //             "value": "Dedham:Readville Manor"
                //         },
                //         {
                //             "name": "Riverdale",
                //             "value": "Dedham:Riverdale"
                //         },
                //         {
                //             "name": "The Manor",
                //             "value": "Dedham:The Manor"
                //         },
                //     ]
                // },
                // {
                //     "name": "Everett",
                //     "value": "Everett",
                //     options: [
                //         {
                //             "name": "Glendale",
                //             "value": "Everett:Glendale"
                //         },
                //         {
                //             "name": "Washington Park",
                //             "value": "Everett:Washington Park"
                //         },
                //         {
                //             "name": "West Everett",
                //             "value": "Everett:West Everett"
                //         },
                //     ]
                // },
                // {
                //     "name": "Lynn",
                //     "value": "Lynn",
                //     options: [
                //         {
                //             "name": "Diamond District",
                //             "value": "Lynn:Diamond District"
                //         },
                //         {
                //             "name": "East Lynn",
                //             "value": "Lynn:East Lynn"
                //         },
                //         {
                //             "name": "Lynn Common",
                //             "value": "Lynn:Lynn Common"
                //         },
                //         {
                //             "name": "Lynn Woods",
                //             "value": "Lynn:Lynn Woods"
                //         },
                //         {
                //             "name": "Lynnhurst",
                //             "value": "Lynn:Lynnhurst"
                //         },
                //         {
                //             "name": "West Lynn",
                //             "value": "Lynn:West Lynn"
                //         },
                //         {
                //             "name": "Wyoma",
                //             "value": "Lynn:Wyoma"
                //         },
                //     ]
                // },
                // {
                //     "name": "Malden",
                //     "value": "Malden",
                //     options: [
                //         {
                //             "name": "Bell Rock",
                //             "value": "Malden:Bell Rock"
                //         },
                //         {
                //             "name": "Belmont Hill",
                //             "value": "Malden:Belmont Hill"
                //         },
                //         {
                //             "name": "Edgeworth",
                //             "value": "Malden:Edgeworth"
                //         },
                //         {
                //             "name": "Faulkner",
                //             "value": "Malden:Faulkner"
                //         },
                //         {
                //             "name": "Fells",
                //             "value": "Malden:Fells"
                //         },
                //         {
                //             "name": "Forestdale",
                //             "value": "Malden:Forestdale"
                //         },
                //         {
                //             "name": "Linden",
                //             "value": "Malden:Linden"
                //         },
                //         {
                //             "name": "Maplewood",
                //             "value": "Malden:Maplewood"
                //         },
                //         {
                //             "name": "Middlesex Fells",
                //             "value": "Malden:Middlesex Fells"
                //         },
                //         {
                //             "name": "Oak Grove",
                //             "value": "Malden:Oak Grove"
                //         },
                //         {
                //             "name": "West End",
                //             "value": "Malden:West End"
                //         },
                //     ]
                // },
                // {
                //     "name": "Medford",
                //     "value": "Medford",
                //     options: [
                //         {
                //             "name": "College Hill",
                //             "value": "Medford:College Hill"
                //         },
                //         {
                //             "name": "Medford Hillside",
                //             "value": "Medford:Medford Hillside"
                //         },
                //         {
                //             "name": "North Medford",
                //             "value": "Medford:North Medford"
                //         },
                //         {
                //             "name": "Tufts University",
                //             "value": "Medford:Tufts University"
                //         },
                //         {
                //             "name": "Wellington",
                //             "value": "Medford:Wellington"
                //         },
                //         {
                //             "name": "West Medford",
                //             "value": "Medford:West Medford"
                //         },
                //     ]
                // },
                // {
                //     "name": "Newton",
                //     "value": "Newton",
                //     options: [
                //         {
                //             "name": "Auburndale",
                //             "value": "Newton:Auburndale"
                //         },
                //         {
                //             "name": "Chestnut Hill",
                //             "value": "Newton:Chestnut Hill"
                //         },
                //         {
                //             "name": "Eliot",
                //             "value": "Newton:Eliot"
                //         },
                //         {
                //             "name": "Newton Center",
                //             "value": "Newton:Newton Center"
                //         },
                //         {
                //             "name": "Newton Corner",
                //             "value": "Newton:Newton Corner"
                //         },
                //         {
                //             "name": "Newton Highlands",
                //             "value": "Newton:Newton Highlands"
                //         },
                //         {
                //             "name": "Newton Lower Falls",
                //             "value": "Newton:Newton Lower Falls"
                //         },
                //         {
                //             "name": "Newton Upper Falls",
                //             "value": "Newton:Newton Upper Falls"
                //         },
                //         {
                //             "name": "Newtonville",
                //             "value": "Newton:Newtonville"
                //         },
                //         {
                //             "name": "Nonantum",
                //             "value": "Newton:Nonantum"
                //         },
                //         {
                //             "name": "Thompsonville",
                //             "value": "Newton:Thompsonville"
                //         },
                //         {
                //             "name": "Waban",
                //             "value": "Newton:Waban"
                //         },
                //         {
                //             "name": "West Newton",
                //             "value": "Newton:West Newton"
                //         },
                //         {
                //             "name": "Woodland Station",
                //             "value": "Newton:Woodland Station"
                //         },
                //     ]
                // },
                // {
                //     "name": "North Andover",
                //     "value": "North Andover",
                //     options: [
                //         {
                //             "name": "Barker",
                //             "value": "North Andover:Barker"
                //         },
                //         {
                //             "name": "College",
                //             "value": "North Andover:College"
                //         },
                //         {
                //             "name": "Downtown",
                //             "value": "North Andover:Downtown"
                //         },
                //         {
                //             "name": "Marble Ridge Station",
                //             "value": "North Andover:Marble Ridge Station"
                //         },
                //         {
                //             "name": "Old Center",
                //             "value": "North Andover:Old Center"
                //         },
                //     ]
                // },
                // {
                //     "name": "North Billerica",
                //     "value": "North Billerica"
                // },
                // {
                //     "name": "North Reading",
                //     "value": "North Reading",
                //     options: [
                //         {
                //             "name": "Martins Pond",
                //             "value": "North Reading:Martins Pond"
                //         },
                //         {
                //             "name": "West Village",
                //             "value": "North Reading:West Village"
                //         },
                //     ]
                // },
                // {
                //     "name": "Peabody",
                //     "value": "Peabody",
                //     options: [
                //         {
                //             "name": "Needham Corner",
                //             "value": "Peabody:Needham Corner"
                //         },
                //         {
                //             "name": "South Peabody",
                //             "value": "Peabody:South Peabody"
                //         },
                //         {
                //             "name": "West Peabody",
                //             "value": "Peabody:West Peabody"
                //         },
                //     ]
                // },
                // {
                //     "name": "Quincy",
                //     "value": "Quincy",
                //     options: [
                //         {
                //             "name": "Adams Shore",
                //             "value": "Quincy:Adams Shore"
                //         },
                //         {
                //             "name": "Atlantic",
                //             "value": "Quincy:Atlantic"
                //         },
                //         {
                //             "name": "Germantown",
                //             "value": "Quincy:Germantown"
                //         },
                //         {
                //             "name": "Houghs Neck",
                //             "value": "Quincy:Houghs Neck"
                //         },
                //         {
                //             "name": "Marina Bay",
                //             "value": "Quincy:Marina Bay"
                //         },
                //         {
                //             "name": "Merrymount",
                //             "value": "Quincy:Merrymount"
                //         },
                //         {
                //             "name": "Montclair",
                //             "value": "Quincy:Montclair"
                //         },
                //         {
                //             "name": "Norfolk Downs",
                //             "value": "Quincy:Norfolk Downs"
                //         },
                //         {
                //             "name": "North Quincy",
                //             "value": "Quincy:North Quincy"
                //         },
                //         {
                //             "name": "Quincy Center",
                //             "value": "Quincy:Quincy Center"
                //         },
                //         {
                //             "name": "Quincy Neck",
                //             "value": "Quincy:Quincy Neck"
                //         },
                //         {
                //             "name": "Quincy Point",
                //             "value": "Quincy:Quincy Point"
                //         },
                //         {
                //             "name": "Rock Island",
                //             "value": "Quincy:Rock Island"
                //         },
                //         {
                //             "name": "South Quincy",
                //             "value": "Quincy:South Quincy"
                //         },
                //         {
                //             "name": "Squantum",
                //             "value": "Quincy:Squantum"
                //         },
                //         {
                //             "name": "West Quincy",
                //             "value": "Quincy:West Quincy"
                //         },
                //         {
                //             "name": "Wollaston",
                //             "value": "Quincy:Wollaston"
                //         },
                //         {
                //             "name": "Wollaston Heights",
                //             "value": "Quincy:Wollaston Heights"
                //         },
                //     ]
                // },
                // {
                //     "name": "Randolph",
                //     "value": "Randolph",
                //     options: [
                //         {
                //             "name": "North Randolph",
                //             "value": "Randolph:North Randolph"
                //         },
                //         {
                //             "name": "South Randolph",
                //             "value": "Randolph:South Randolph"
                //         },
                //     ]
                // },
                // {
                //     "name": "Revere",
                //     "value": "Revere",
                //     options: [
                //         {
                //             "name": "Beachmont",
                //             "value": "Revere:Beachmont"
                //         },
                //         {
                //             "name": "Crescent Beach",
                //             "value": "Revere:Crescent Beach"
                //         },
                //         {
                //             "name": "Franklin Park",
                //             "value": "Revere:Franklin Park"
                //         },
                //         {
                //             "name": "Oak Island",
                //             "value": "Revere:Oak Island"
                //         },
                //         {
                //             "name": "Point of Pines",
                //             "value": "Revere:Point of Pines"
                //         },
                //         {
                //             "name": "Revere Beach",
                //             "value": "Revere:Revere Beach"
                //         },
                //     ]
                // },
                // {
                //     "name": "Salisbury",
                //     "value": "Salisbury",
                //     options: [
                //         {
                //             "name": "Cushing",
                //             "value": "Salisbury:Cushing"
                //         },
                //         {
                //             "name": "Rings Island",
                //             "value": "Salisbury:Rings Island"
                //         },
                //         {
                //             "name": "Salisbury Beach",
                //             "value": "Salisbury:Salisbury Beach"
                //         },
                //         {
                //             "name": "Salisbury Center",
                //             "value": "Salisbury:Salisbury Center"
                //         },
                //         {
                //             "name": "Salisbury Plains",
                //             "value": "Salisbury:Salisbury Plains"
                //         },
                //     ]
                // },
                // {
                //     "name": "Saugus",
                //     "value": "Saugus",
                //     options: [
                //         {
                //             "name": "Cliftondale",
                //             "value": "Saugus:Cliftondale"
                //         },
                //         {
                //             "name": "East Saugus",
                //             "value": "Saugus:East Saugus"
                //         },
                //         {
                //             "name": "Lynnhurst",
                //             "value": "Saugus:Lynnhurst"
                //         },
                //         {
                //             "name": "North Saugus",
                //             "value": "Saugus:North Saugus"
                //         },
                //         {
                //             "name": "Vinegar Hill",
                //             "value": "Saugus:Vinegar Hill"
                //         },
                //     ]
                // },
                {
                    "name": "Somerville",
                    "value": "Somerville",
                    options: [
                        {
                            "name": "Ball Square",
                            "value": "Somerville:Ball Square"
                        },
                        {
                            "name": "Davis Square",
                            "value": "Somerville:Davis Square"
                        },
                        {
                            "name": "East Somerville",
                            "value": "Somerville:East Somerville"
                        },
                        {
                            "name": "Inman Square",
                            "value": "Somerville:Inman Square"
                        },
                        {
                            "name": "Powderhouse Square",
                            "value": "Somerville:Powderhouse Square"
                        },
                        {
                            "name": "Prospect Hill",
                            "value": "Somerville:Prospect Hill"
                        },
                        {
                            "name": "Spring Hill",
                            "value": "Somerville:Spring Hill"
                        },
                        {
                            "name": "Teele Square",
                            "value": "Somerville:Teele Square"
                        },
                        {
                            "name": "Union Square",
                            "value": "Somerville:Union Square"
                        },
                        {
                            "name": "West Somerville",
                            "value": "Somerville:West Somerville"
                        },
                        {
                            "name": "Winter Hill",
                            "value": "Somerville:Winter Hill"
                        },
                    ]
                },
                // {
                //     "name": "Tewksbury",
                //     "value": "Tewksbury",
                //     options: [
                //         {
                //             "name": "North Tewksbury",
                //             "value": "Tewksbury:North Tewksbury"
                //         },
                //         {
                //             "name": "Pattenville",
                //             "value": "Tewksbury:Pattenville"
                //         },
                //         {
                //             "name": "South Lowell",
                //             "value": "Tewksbury:South Lowell"
                //         },
                //         {
                //             "name": "Tewksbury Junction",
                //             "value": "Tewksbury:Tewksbury Junction"
                //         },
                //         {
                //             "name": "Wamesit",
                //             "value": "Tewksbury:Wamesit"
                //         },
                //     ]
                // },
                // {
                //     "name": "Wakefield",
                //     "value": "Wakefield",
                //     options: [
                //         {
                //             "name": "Greenwood",
                //             "value": "Wakefield:Greenwood"
                //         },
                //         {
                //             "name": "Montrose",
                //             "value": "Wakefield:Montrose"
                //         },
                //         {
                //             "name": "Wakefield Junction",
                //             "value": "Wakefield:Wakefield Junction"
                //         },
                //         {
                //             "name": "Wakefield Park",
                //             "value": "Wakefield:Wakefield Park"
                //         },
                //     ]
                // },
                // {
                //     "name": "Waltham",
                //     "value": "Waltham",
                //     options: [
                //         {
                //             "name": "Cedarwood",
                //             "value": "Waltham:Cedarwood"
                //         },
                //         {
                //             "name": "Clematis Brook",
                //             "value": "Waltham:Clematis Brook"
                //         },
                //         {
                //             "name": "Lakeview",
                //             "value": "Waltham:Lakeview"
                //         },
                //         {
                //             "name": "North Waltham",
                //             "value": "Waltham:North Waltham"
                //         },
                //         {
                //             "name": "Piety Corner",
                //             "value": "Waltham:Piety Corner"
                //         },
                //         {
                //             "name": "Pigeon Hill",
                //             "value": "Waltham:Pigeon Hill"
                //         },
                //         {
                //             "name": "Prospectville",
                //             "value": "Waltham:Prospectville"
                //         },
                //         {
                //             "name": "South Waltham",
                //             "value": "Waltham:South Waltham"
                //         },
                //     ]
                // },
                // {
                //     "name": "Watertown",
                //     "value": "Watertown",
                //     options: [
                //         {
                //             "name": "Bemis",
                //             "value": "Watertown:Bemis"
                //         },
                //         {
                //             "name": "East Watertown",
                //             "value": "Watertown:East Watertown"
                //         },
                //         {
                //             "name": "Mount Auburn",
                //             "value": "Watertown:Mount Auburn"
                //         },
                //     ]
                // },
                // {
                //     "name": "Winchester",
                //     "value": "Winchester",
                //     options: [
                //         {
                //             "name": "Symmes Corner",
                //             "value": "Winchester:Symmes Corner"
                //         },
                //         {
                //             "name": "Wedgemere",
                //             "value": "Winchester:Wedgemere"
                //         },
                //         {
                //             "name": "Winchester Highlands",
                //             "value": "Winchester:Winchester Highlands"
                //         },
                //     ]
                // },
                // {
                //     "name": "Woburn",
                //     "value": "Woburn",
                //     options: [
                //         {
                //             "name": "Central Square",
                //             "value": "Woburn:Central Square"
                //         },
                //         {
                //             "name": "Cummingsville",
                //             "value": "Woburn:Cummingsville"
                //         },
                //         {
                //             "name": "North Woburn",
                //             "value": "Woburn:North Woburn"
                //         },
                //         {
                //             "name": "Shaker Glen",
                //             "value": "Woburn:Shaker Glen"
                //         },
                //         {
                //             "name": "Walnut Hill",
                //             "value": "Woburn:Walnut Hill"
                //         },
                //         {
                //             "name": "Woburn Highlands",
                //             "value": "Woburn:Woburn Highlands"
                //         }
                //     ]
                // },
            ]
        },
		{
			name: 'Price',
			type: 'range',
			min_option: {
				name: 'Minimum',
				field: 'min_rent',
				options: [
					{
						name: 'No Min',
						value: null,
					},
					{
						name: '$1,000',
						value: '1000',
					},
					{
						name: '$2,000',
						value: '3000',
					},
					{
						name: '$3,000',
						value: '4000',
					},
					{
						name: '$4,000',
						value: '4000',
					},
					{
						name: '$5,000',
						value: '5000',
					},
				]
			},
			max_option: {
				name: 'Maximum',
				field: 'max_rent',
				options: [
					{
						name: 'No Max',
						value: null,
					},
					{
						name: '$1,000',
						value: '1000',
					},
					{
						name: '$2,000',
						value: '2000',
					},
					{
						name: '$3,000',
						value: '3000',
					},
					{
						name: '$4,000',
						value: '4000',
					},
					{
						name: '$5,000',
						value: '5000',
					},
				]
			},
		},
		{
			name: 'Beds',
			field: 'beds',
			label: 'Bedrooms',
			type: 'pills',
			options: [
				{
					name: 'Any',
					value: null,
				},
				{
					name: 'Studio',
					value: 0,
				},
				{
					name: '1',
					value: 1,
				},
				{
					name: '2',
					value: 2,
				},
				{
					name: '3',
					value: 3,
				},
				{
					name: '4+',
					value: '4,5,6,7,8',
				},
			]
		},
		{
			name: 'Baths',
			field: 'baths',
			label: 'Bathrooms',
			type: 'pills',
			options: [
				{
					name: 'Any',
					value: null,
				},
				{
					name: '1+',
					value: '1,2,3,4,5,6,7,8',
				},
				{
					name: '2+',
					value: '2,3,4,5,6,7,8',
				},
				{
					name: '3+',
					value: '3,4,5,6,7,8',
				},
			]
		},
		{
			name: 'Pets',
			field: 'pet',
			label: 'Pet Friendly',
			type: 'pills',
			options: [
				{
					name: 'Any',
					value: null,
				},
				{
					name: 'Cats',
					value: 'cat',
				},
				{
					name: 'Dogs',
					value: 'dog',
				},
				{
					name: 'Both',
					value: 'friendly',
				},
			]
		},
		{
			name: 'Other',
			type: 'true_false',
			options: [
				{
					name: 'Photo',
					field: 'photo',
					value: 'Y',
				},
			]
		},
	],
	sortBy: [
		{
			name: 'Best Match',
			sort_dir: null,
			sort_name: null,
		},
		{
			name: 'Last Updated',
			sort_dir: 'desc',
			sort_name: 'updateDate',
		},
		{
			name: 'Rent (low to high)',
			sort_dir: 'asc',
			sort_name: 'rent',
		},
		{
			name: 'Rent (high to low)',
			sort_dir: 'desc',
			sort_name: 'rent',
		}
	],
	filterNicenames: {
		photo: {
			Y: 'Photo'
		},
		pet: {
			friendly: 'Pet Friendly',
			cat: 'Cats',
			dog: 'Dogs',
		},
		baths: {
			'1,2,3,4,5,6,7,8': '1+ Baths',
			'2,3,4,5,6,7,8': '2+ Baths',
			'3,4,5,6,7,8': '3+ Baths',
		},
		beds: {
			0: 'Studio',
			1: '1 Bed',
			2: '2 Beds',
			3: '3 Beds',
			'4,5,6,7,8': '4+ Beds',
		},
		min_rent: {
			1000: 'Min $1,000',
			2000: 'Min $2,000',
			3000: 'Min $3,000',
			4000: 'Min $4,000',
			5000: 'Min $5,000',
		},
		max_rent: {
			1000: 'Max $1,000',
			2000: 'Max $2,000',
			3000: 'Max $3,000',
			4000: 'Max $4,000',
			5000: 'Max $5,000',
		},
	}
};